import Vue from "vue";

export default {
  prematchMatches(state, matches) {
    state.prematch.matches = matches;
  },
  updatePrematchMatch(state, { _id, match }) {
    let index = state.prematch.matches.findIndex(m => m._id === _id);
    if (index >= 0)
      Vue.set(state.prematch.matches, index, Object.assign({}, match));
  },
  createPrematchMatch(state, { _id, match }) {
    let index = state.prematch.matches.findIndex(m => m._id === _id);
    if (index >= 0) return;
    state.prematch.matches.push(match);
  },
  deletePrematchMatch(state, _id) {
    let index = state.prematch.matches.findIndex(m => m._id === _id);
    if (index >= 0) state.prematch.matches.splice(index, 1);
  },
  prematchCompanyId(state, id) {
    state.prematch.filters.companyId = id;
  },
  prematchChangesOnly(state, status) {
    state.prematch.filters.changesOnly = status;
  },
  prematchSort(state, s) {
    const oldValue = state.prematch.sort[s];
    const newValue = oldValue === false ? null : oldValue === null;
    Object.keys(state.prematch.sort).forEach(key => {
      state.prematch.sort[key] = null;
    });
    state.prematch.sort[s] = newValue;
  }
};
